module.exports = __webpack_public_path__ + "static/img/zz.4d4f8149.png";